import React from 'react';
import Markdown from 'react-markdown';
import type { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';

// Shared markdown renderer — used by SideBySideDiff's "preview" toggle (and
// available for rendering other markdown bodies identically).

const MarkdownDiv = styled.div`
  color: var(--color-text-primary);
  line-height: 1.65;
  min-width: 0;
  overflow-wrap: break-word;

  p,
  li,
  td,
  th {
    color: var(--color-text-primary);
  }

  h1,
  h2,
  h3 {
    color: var(--color-text-primary);
  }

  code {
    background-color: var(--color-bg-tertiary);
    color: var(--color-text-secondary);
    border-radius: 4px;
    padding: 2px 6px;
  }

  pre {
    overflow-x: auto;
  }

  img {
    max-width: 100%;
  }

  table {
    border-collapse: collapse;
  }

  td,
  th {
    border: 1px solid var(--color-border-secondary);
    padding: 6px 10px;
    text-align: left;
  }
`;

// Wide GFM tables (e.g. per-connector binding tables) get their own horizontal
// scroll box, so a table wider than the panel scrolls inside it instead of
// pushing the page out. Only `children` is needed — the cell styling comes from
// MarkdownDiv above.
const TableScroll = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

const COMPONENTS: Components = {
  table: ({ children }) => (
    <TableScroll>
      <table>{children}</table>
    </TableScroll>
  ),
};

const MarkdownBody = ({ children }: { children: string }) => (
  <MarkdownDiv>
    <Markdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>
      {children}
    </Markdown>
  </MarkdownDiv>
);

export default MarkdownBody;
